import Cookies from 'js-cookie';
import { TOKEN } from 'src/common/const';

export const getToken = () => {
  return Cookies.get('next_auth') ?? localStorage.getItem(TOKEN);
};
